import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TowerUnitsState {
  loading: boolean;
  error: string | null;
  data: any[];
}

const initialState: TowerUnitsState = {
  loading: false,
  error: null,
  data: [],
};

const towerUnitsSlice = createSlice({
  name: "towerUnits",
  initialState,
  reducers: {
    fetchTowerUnitsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchTowerUnitsSuccess(state, action: PayloadAction<any[]>) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchTowerUnitsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearTowerUnits(state) {
      state.data = [];
      state.error = null;
      state.loading = false;
    }
  },
});

export const {
  fetchTowerUnitsStart,
  fetchTowerUnitsSuccess,
  fetchTowerUnitsError,
  clearTowerUnits,
} = towerUnitsSlice.actions;

export default towerUnitsSlice.reducer;
